import React from "react";
import * as Icons from "lucide-react";
import { WHY_CHOOSE } from "../data/site";

export default function WhyChoose() {
  return (
    <section id="why" data-testid="why-choose-section" className="py-20 lg:py-32 bg-[#F7F9FC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="overline mb-4">Why Choose Babul</div>
          <h2 className="section-heading text-navy text-3xl md:text-4xl lg:text-5xl font-bold">
            Everything overseas buyers need — from a single, dependable partner.
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Eight pillars that make Babul Corporation the go-to sourcing partner for
            Indian FMCG exports.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {WHY_CHOOSE.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <div
                key={i}
                data-testid={`why-card-${i}`}
                className="card-hover bg-white rounded-2xl p-7 border border-slate-100 shadow-sm"
              >
                <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-navy text-white mb-5">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="font-display text-xl text-navy font-bold leading-snug">
                  {f.title}
                </div>
                <p className="mt-3 text-slate-600 text-sm leading-relaxed">{f.desc}</p>
                <div className="mt-5 h-px w-10 bg-gold" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
